import { Redirect } from 'expo-router';
import { useLeagueContext } from '@/contexts/LeagueContext';
import MarchMadnessLeagueView from '@/components/MarchMadnessLeagueView';
import AppHeader from '@/components/AppHeader';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import { Box } from '@/components/ui/primitives';
import { getLandingHref } from '@/lib/routes';

export default function LeagueRostersRoute() {
  const context = useLeagueContext();
  const id = context.id;

  if (!id || id === 'undefined') {
    return <Redirect href={getLandingHref()} />;
  }

  const { league, resolvedSeasonId } = context;

  const headerTitle = league?.name ?? 'League';

  return (
    <NativeTabFocusGate>
      <Box flex={1} backgroundColor="background">
        <AppHeader title={headerTitle} currentLeagueId={id} allowBack={false} />
        <Box flex={1}>
          <MarchMadnessLeagueView
            leagueId={id}
            seasonId={resolvedSeasonId || ''}
            section="rosters"
            currentUserId={context.league?.currentUserId}
            permissions={context.permissions}
          />
        </Box>
      </Box>
    </NativeTabFocusGate>
  );
}
